<template>
    <div class="con-btn">
        <div v-if="!shopFlag">
            <div class="swb-btn swb-btn-mini" @click="selectSrcCom">选择订阅机构</div>
            <div class="pt10 font12 font-gray3">
                <span>已选订阅机构（{{srcComList.length}}）：</span>
                <span class="mr10 mb10" v-for="srcComInfo in srcComList">{{srcComInfo.name}}</span>
            </div>
        </div>
        <div class="msg-subscr-msanage" v-for="bizTopic in bizTopicList">
            <div v-if="bizTopic.bizEventMsgList != null && bizTopic.bizEventMsgList.length > 0">
                <div class="message-tips">
                    <div class="inline-block mr20">
                        <span class="font-gray1">主题：</span>
                        <el-checkbox v-model="bizTopic.checked" :indeterminate="bizTopic.indeterminate" @change="((event)=>{selectBizTopicMethod(event, bizTopic.id)})">
                            <span>{{bizTopic.name}}</span>
                        </el-checkbox>
                    </div>
                </div>
                <div class="message-body">
                    <ul class="native-table">
                        <li class="table-tr">
                            <div class="table-th" style="width: 150px; text-align: left;">消息名称</div>
                            <div class="table-th" style="text-align: left;">消息内容</div>
                            <div class="table-th" style="width: 700px;">支持方式</div>
                        </li>
                        <li class="table-tr" :class="bizEventMsg.vipLevel > currentVipLevel ? 'vipCtrl' : ''" v-for="bizEventMsg in bizTopic.bizEventMsgList">
                            <div class="table-td" style="text-align: left;">
                                <el-checkbox v-model="bizEventMsg.checked" :disabled="bizEventMsg.vipLevel > currentVipLevel" @change="checkState(bizTopic.id)" class="ml20">
                                    <span>{{bizEventMsg.name}}</span>
                                </el-checkbox>
                            </div>
                            <div class="table-td" style="text-align: left;">{{bizEventMsg.renderContent}}</div>
                            <div class="table-td" style="text-align: left;">
                                <span v-if="bizEventMsg.siteMsgFlag">
                                    <el-checkbox class="ml20" v-model="bizEventMsg.selectSiteMsgFlag" :disabled="true">站内信</el-checkbox>
                                </span>
                                <span v-if="bizEventMsg.emailFlag">
                                    <el-checkbox class="ml20" v-model="bizEventMsg.selectEmailFlag" :disabled="true">邮件</el-checkbox>
                                </span>
                                <span v-if="bizEventMsg.wxFlag">
                                    <el-checkbox class="ml20" v-model="bizEventMsg.selectWxFlag" :disabled="true">微信</el-checkbox>
                                </span>
                                <span v-if="bizEventMsg.selectWxFlag">
                                    <el-checkbox class="ml20" v-model="bizEventMsg.selectMiniApp" :disabled="bizEventMsg.vipLevel > currentVipLevel">选择小程序</el-checkbox>
                                </span>
                                <div v-if="bizEventMsg.selectMiniApp && bizEventMsg.selectWxFlag" class="inline-block">
                                    <div class="inline-block ml10" v-if="bizEventMsg.bizEventMsgAppList != null && bizEventMsg.bizEventMsgAppList.length > 0">
                                        <el-radio-group v-model="bizEventMsg.appAlias" :disabled="bizEventMsg.vipLevel > currentVipLevel">
                                            <el-radio v-for="eventMsgApp in bizEventMsg.bizEventMsgAppList" :label="eventMsgApp.appAlias">
                                                <span>{{miniAppAliases[eventMsgApp.appAlias]}}</span>
                                            </el-radio>
                                        </el-radio-group>
                                    </div>
                                    <span class="font-red ml10" v-else>未设置小程序</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openServicerComListForSelectDlg } from '../orgStruct/selectDlg'

    //
    import bizMsgApi from '../../api/bizMsg'
    import userApi from '../../api/user'
    //
    export default {
        name: 'swb-biz-event-msg-tpl-subscr-save',
        desc: '消息模版订阅保存',
        props: {
            tplId: {
                type: Number,
                default: null
            },
            shopFlag: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                currentVipLevel: null,
                scopeEntity: [],
                //
                miniAppAliases: {},
                //
                bizTopicList: [],
                //
                vipLevel: {},
                //
                srcComList: [],
            }
        },
        created: function () {
            this.miniAppAliases = {
                "servicerEngin": "服务商服务工程师",
                "servicerServc": "服务商服务管理"
            };
            //
            this.vipLevel = getEnumMap("vipLevel", "value2text");
            // 获取当前商户信息
            this.getCurrentUserInfo();
        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                let data = {};
                userApi.getUserInfoByContext(data, function (result) {
                    if(result.type === "info") {
                        let userInfo = result.data;
                        let scopeEntity = userInfo.scopeEntity;
                        //
                        self.currentVipLevel = scopeEntity.vipLevel;
                        self.scopeEntity = scopeEntity;
                        //
                        self.getBizTopicList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getBizTopicList: function () {  // 获取主题-事件
                let self = this;
                let postData = {};
                let theLoad = MsgBox.loading();
                bizMsgApi.getBizTopicList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let bizTopicList = result.data;
                        let bizEventMsgIds = [];
                        if(bizTopicList != null && bizTopicList.length > 0) {
                            bizTopicList.forEach(function (bizTopic) {
                                // 设置默认值
                                bizTopic.checked = false;   // 是否选中
                                bizTopic.indeterminate = false;
                                //
                                let bizEventMsgList = bizTopic.bizEventMsgList;
                                if(bizEventMsgList != null && bizEventMsgList.length > 0) {     // 事件
                                    let msgIds = bizEventMsgList.pluck('id');
                                    bizEventMsgIds.add(msgIds);
                                    bizEventMsgList.forEach(function (bizEventMsg) {
                                        //
                                        bizEventMsg.checked = false;   // 是否选中
                                        // 支持方式 -  支持及默认选中
                                        bizEventMsg.selectSiteMsgFlag = bizEventMsg.siteMsgFlag; //
                                        bizEventMsg.selectEmailFlag = bizEventMsg.siteMsgFlag;
                                        bizEventMsg.selectWxFlag = bizEventMsg.siteMsgFlag;
                                        bizEventMsg.selectMiniApp = true;
                                    });
                                }
                            });
                        }
                        self.bizTopicList = bizTopicList;
                        self.getBizEventMsgAppList(bizEventMsgIds, function (bizEventMsgAppList) {
                            if(bizTopicList != null && bizTopicList.length > 0) {
                                bizTopicList.forEach(function (bizTopic) {
                                    let bizEventMsgList = bizTopic.bizEventMsgList;
                                    if(bizEventMsgList != null && bizEventMsgList.length > 0) {
                                        bizEventMsgList.forEach(function (bizEventMsg) {
                                            let bizEventMsg_MsgAppList = [];
                                            if(bizEventMsgAppList != null && bizEventMsgAppList.length > 0) {
                                                bizEventMsgAppList.forEach(function (bizEventMsgApp) {
                                                    if(bizEventMsg.id == bizEventMsgApp.eventMsgId) {
                                                        bizEventMsg_MsgAppList.push(bizEventMsgApp);
                                                    }
                                                });
                                                if(bizEventMsg_MsgAppList.length > 0) {
                                                    bizEventMsg.appAlias = bizEventMsg_MsgAppList[0].appAlias || null;
                                                } else {
                                                    bizEventMsg.appAlias = null;
                                                    bizEventMsg.selectMiniApp = false;
                                                }
                                            } else {
                                                bizEventMsg.appAlias = null;
                                                bizEventMsg.selectMiniApp = false;
                                            }
                                            bizEventMsg.bizEventMsgAppList = bizEventMsg_MsgAppList;
                                        });
                                    }
                                });
                            }
                            self.getBizEventMsgTplSubscrList();
                        });
                    } else {
                        MsgBox.warning(result.message);
                        theLoad.close();
                    }
                });
            },
            getBizEventMsgAppList(bizEventMsgIds, callback) {    // 获取每个事件支持的小程序
                let self = this;
                let postData = {};
                postData.eventMsgIds = bizEventMsgIds;
                //
                let theLoad = MsgBox.loading();
                bizMsgApi.getBizEventMsgAppListByMsgIds(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        callback(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getBizEventMsgTplSubscrList(){
                let self = this;
                let postData = {};
                postData.tplId = self.tplId;
                let theLoad = MsgBox.loading();
                bizMsgApi.getBizEventMsgTplSubscrList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let tplSubscrList = result.data;
                        //
                        let bizTopicList = self.handleTplSubscrList(self.bizTopicList, tplSubscrList);
                        self.bizTopicList = Utils.merge([], bizTopicList);
                        self.checkState(null);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 处理回显
            handleTplSubscrList(bizTopicList, tplSubscrList){
                let self = this;
                if(bizTopicList != null && bizTopicList.length > 0 && tplSubscrList != null && tplSubscrList.length > 0) {
                    let srcComList = [];
                    let srcComIds = [];
                    bizTopicList.forEach(function (bizTopic) {
                        let bizEventMsgList = bizTopic.bizEventMsgList;
                        if(bizEventMsgList != null && bizEventMsgList.length > 0) {
                            bizEventMsgList.forEach(function (bizEventMsg) {
                                tplSubscrList.forEach(function (tplSubscr) {
                                    if(bizEventMsg.id == tplSubscr.eventMsgId) {
                                        bizEventMsg.checked = true;
                                        bizEventMsg.selectSiteMsgFlag = tplSubscr.siteMsgFlag;
                                        bizEventMsg.selectEmailFlag = tplSubscr.emailFlag;
                                        bizEventMsg.selectWxFlag = tplSubscr.wxFlag;
                                        bizEventMsg.selectMiniApp = tplSubscr.miniAppAlias != null;
                                        bizEventMsg.appAlias = tplSubscr.miniAppAlias;
                                        //
                                        if(srcComIds.indexOf(tplSubscr.srcComId) < 0) {
                                            let comInfo = {
                                                id: tplSubscr.srcComId,
                                                name: tplSubscr.srcComName,
                                                level: tplSubscr.srcComLevel,
                                            };
                                            srcComIds.push(tplSubscr.srcComId);
                                            srcComList.push(comInfo);
                                        }
                                    }
                                });
                            });
                        }
                    });
                    this.srcComList = Utils.merge([], srcComList);
                }
                return bizTopicList;
            },
            // 选择主题 - 方法
            selectBizTopicMethod(checked, topicId) {
                let bizTopicInfo = null;
                let bizTopicList = this.bizTopicList || [];
                let currentVipLevel = this.currentVipLevel;
                bizTopicList.forEach(function (bizTopic) {
                    if(bizTopic.id == topicId) {
                        bizTopic.indeterminate = false;
                        bizTopic.bizEventMsgList.forEach(function (eventMsg) {
                            if(eventMsg.vipLevel <= currentVipLevel) {
                                eventMsg.checked = checked;
                            }
                        });
                    }
                });
                this.bizTopicList = bizTopicList;
            },
            checkState(topicId){
                let bizTopicList = this.bizTopicList || [];
                let currentVipLevel = this.currentVipLevel;
                bizTopicList.forEach(function (bizTopic) {
                    if(topicId == null || bizTopic.id == topicId) {
                        let noInclude = false; // 是否有没选中的
                        let include = false;    // 是否有选中的
                        bizTopic.bizEventMsgList.forEach(function (eventMsg) {
                            if(eventMsg.vipLevel <= currentVipLevel) {
                                if(eventMsg.checked) {
                                    include = true;
                                } else {
                                    noInclude = true;
                                }
                            }
                        });
                        let checked = true;
                        let indeterminate = false;
                        if(noInclude && !include) {
                            checked = false; // 全不选
                        } else if(include && noInclude) {
                            indeterminate = true; // 半选
                        }
                        bizTopic.checked = checked;
                        bizTopic.indeterminate = indeterminate;
                    }
                });
            },
            // 选择订阅公司信息
            selectSrcCom: function () {
                let self = this;
                let srcComList = this.srcComList || [];
                let queryFilter = {
                    checkedComList: srcComList
                };
                openServicerComListForSelectDlg(queryFilter, function (resultData, theDlg) {
                    let srcComList = resultData;
                    if(!Utils.isNoB(srcComList) && srcComList.length > 200) {
                        MsgBox.warning("订阅机构一次对多支持200个");
                    } else {
                        theDlg.close();
                        self.srcComList = resultData;
                    }
                });
            },
            handeFirst(bizTopic, bizEventMsg){
                let topicInfo = {};
                topicInfo.id = bizTopic.id;
                topicInfo.name = bizTopic.name;
                topicInfo.bizEventMsgDtos = [bizEventMsg];
                return topicInfo;
            },
            //
            getDlgResult: function () {
                let self = this;
                let srcComList = this.srcComList || [];
                if(self.shopFlag) {     // 网点专用模板
                    srcComList = [{
                        id: -1,
                        name: "",
                        level: -1,
                    }]
                } else {
                    if(srcComList.length <= 0) {
                        MsgBox.warning("请选择订阅机构！");
                        return null;
                    }
                }
                //
                let bizTopicList = this.bizTopicList;
                let selectBizTopicList = [];
                bizTopicList.forEach(function (bizTopic) {
                    let bizEventMsgList = bizTopic.bizEventMsgList;
                    if(bizEventMsgList != null && bizEventMsgList.length > 0) {

                        bizEventMsgList.forEach(function (bizEventMsg) {
                            if(bizEventMsg.checked) {
                                // 设置订阅公司信息
                                for(let i = 0; i < srcComList.length; i++) {
                                    let theBizEventMsg = Utils.merge({}, bizEventMsg);
                                    let comInfo = srcComList[i];
                                    theBizEventMsg.srcComId = comInfo.id;
                                    theBizEventMsg.srcComName = comInfo.name;
                                    theBizEventMsg.srcComLevel = comInfo.level;
                                    if(selectBizTopicList.length == 0) {
                                        let topicInfo = self.handeFirst(bizTopic, theBizEventMsg);
                                        selectBizTopicList.push(topicInfo);
                                    } else {
                                        let theSelectBizTopic = selectBizTopicList.find(function (selectBizTopic) {
                                            return selectBizTopic.id == bizTopic.id;
                                        });
                                        if(Utils.isNoB(theSelectBizTopic)) {
                                            let topicInfo = self.handeFirst(bizTopic, theBizEventMsg);
                                            selectBizTopicList.push(topicInfo);
                                        } else {
                                            theSelectBizTopic.bizEventMsgDtos.push(theBizEventMsg);
                                        }
                                    }
                                }
                            }
                        });
                    }
                });
                if(selectBizTopicList == null || selectBizTopicList.length <= 0) {
                    MsgBox.warning("请选择要订阅的事件！");
                    return null;
                }
                // 设置最新-分类信息 + 校验
                for(let i = 0; i < selectBizTopicList.length; i++) {
                    let bizTopic = selectBizTopicList[i];
                    let bizEventMsgDtos = bizTopic.bizEventMsgDtos || [];
                    if(bizEventMsgDtos != null && bizEventMsgDtos.length > 0) {
                        for(let i = 0; i < bizEventMsgDtos.length; i++) {
                            let bizEventMsg = bizEventMsgDtos[i];
                            if(!bizEventMsg.selectWxFlag || !bizEventMsg.selectMiniApp) {    // 不选择小程序 - 小程序设置为null
                                bizEventMsg.appAlias = null;
                            } else {
                                // 选择小程序 - 校验小程序不可为空！
                                if(Utils.isNoB(bizEventMsg.appAlias)) {
                                    MsgBox.warning("【" + bizEventMsg.name + "】未设置小程序！");
                                    return null;
                                }
                            }
                        }
                    } else {
                        MsgBox.warning("请选择要订阅的事件！");
                        return null;
                    }
                }
                //
                let bizEventMsgSubscrDto = {};
                bizEventMsgSubscrDto.tplId = self.tplId;
                bizEventMsgSubscrDto.bizTopicDtos = selectBizTopicList;
                //
                return bizEventMsgSubscrDto;
            }
        }
    }
</script>

<style>
    .table-tr.vipCtrl:after {
        content: 'vip等级不满足';
        position: absolute;
        left: 20px;
        width: 100px;
        height: 30px;
        display: block;
        text-align: center;
        line-height: 30px;
        background-color: #fff6f6;
        border: 1px solid #D71718;
        color: black;
        opacity: 0.5;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transform: rotate(-16deg);
        -ms-transform: rotate(-16deg); /* IE 9 */
        -moz-transform: rotate(-16deg); /* Firefox */
        -webkit-transform: rotate(-16deg); /* Safari 和 Chrome */
        -o-transform: rotate(-16deg); /* Opera */
    }
</style>




// WEBPACK FOOTER //
// src/compo/bizMsg/BizEventMsgTplSubscrSave.vue